import React, { useEffect, useState } from 'react';

import { TouchableOpacity } from 'react-native';

import EditScreenInfo from '../components/EditScreenInfo';
import { Text, View } from '../components/Themed';
import {
    LineChart,
    BarChart,
    PieChart,
    ProgressChart,
    ContributionGraph,
    StackedBarChart
} from "react-native-chart-kit";
import {  log, logerror } from './Common';
import moment from 'moment';

export default class SubStatsDailycounts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datas: [],
            type: this.props.type,
            title: this.props.title,
            w: parseInt(this.props.w),
            h: parseInt(this.props.h),
            currentTime: "",
        }
    }
    // This method will execute everytime a state or props change.
    componentDidUpdate(prevProps) {
    }
    componentDidMount(props) {
        this.getDatas();
    }
    handleData(datax) {
        var resultx = [];
        // log('handleData ' + JSON.stringify(datax));
        // log('handleData parse ' + JSON.stringify(datax[0]));
        // log('handleData lenght ' + Object.keys(datax).length);
        var oldx = 0;
        for (var i = 0; i < datax.length; i++) {
            var obj = datax[i];
            // log('handleData for ' + JSON.stringify(obj));
            if (this.state.type == "1") {
                oldx = obj.count
            }
            if (this.state.type == "2") {
                oldx = oldx + obj.count
            }
            resultx.push(oldx);
        }
        // log('handleData parse ' + JSON.stringify(resultx));
        this.state.datas = resultx;
   
        var formattedDate = moment().format("HH:mm:ss"); // "Monday, August 12th 2019, 5:52:00 pm"
        this.state.currentTime = formattedDate;
   }

    getDatas = () => {
        fetch(global.docker + 'monitor/countdayapicalls', {
            method: 'get',
            headers: {
                'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
                'Content-Type': 'application/json'
            }
        }
        )
            .then((response) => response.json())
            .then((json) => this.handleData(json))
            .catch((error) => logerror("getDatas", error))
            .finally(() => this.setState({ loadingphotosgroup: false })
            );
    }



    render() {
        return (
            <TouchableOpacity
            onPress={() => this.getDatas()}   >
  <View >
                <Text >
                {this.state.title} {this.state.currentTime} 
                </Text>

                <LineChart
                    data={{
                        datasets: [
                            {
                                data: this.state.datas
                            }
                        ]
                    }}
                    width={this.state.w} // from react-native
                    height={this.state.h} // from react-native
                    yAxisLabel=""
                    yAxisSuffix=""
                    yAxisInterval={10} // optional, defaults to 1
                    chartConfig={{
                        backgroundColor: "#332211",
                        backgroundGradientFrom: "#664422",
                        backgroundGradientTo: "#221100",
                        decimalPlaces: 0, // optional, defaults to 2dp
                        color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                        labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
                        style: {
                            borderRadius: 16
                        },
                        propsForDots: { 
                            
                            r: "1",
                            strokeWidth: "0",
                            stroke: "#ffa726"
                        }
                    }}
                    style={{
                        marginVertical: 8,
                        borderRadius: 8
                    }}
                />
            </View>
            </TouchableOpacity>

        )
    }


}